// @ts-nocheck
import { MOCK, invalidateAndRefresh } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api, contentApi, adminApi } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// __legacy_global_aliases__
// Resolve cross-module helpers via window (legacy SPA globals)
const packageAppIdLabel = (...args: any[]) => (window as any).packageAppIdLabel(...args);
const packageDisplayName = (...args: any[]) => (window as any).packageDisplayName(...args);
const packagePlatformCode = (...args: any[]) => (window as any).packagePlatformCode(...args);
const packagePlatformMeta = (...args: any[]) => (window as any).packagePlatformMeta(...args);
const pkgCreds = (...args: any[]) => (window as any).pkgCreds(...args);
const pkgStatusBadge = (...args: any[]) => (window as any).pkgStatusBadge(...args);
const regionFlag = (...args: any[]) => (window as any).regionFlag(...args);
const renderExperimentAnalysisMetric = (...args: any[]) => (window as any).renderExperimentAnalysisMetric(...args);


// ============================================================
// 设置页：个人设置 / 系统参数 / API 密钥
// ============================================================

window.Pages = window.Pages || {};

Pages.settingsProfile = function () {
  const r = MOCK.ROLES[MOCK.SESSION.currentRole];
  return `
    ${UI.pageHeader({ title: "个人设置", desc: "管理您的账户信息与偏好" })}

    <div class="grid grid-cols-3 gap-4">
      <!-- 头像与基本信息 -->
      <div class="card p-6 text-center">
        <div id="profile-avatar-preview" class="w-20 h-20 mx-auto rounded-full bg-brand-700 flex items-center justify-center text-white text-2xl font-bold overflow-hidden">${r.avatar}</div>
        <div class="text-base font-semibold mt-3">${r.user}</div>
        <div class="text-xs text-ink-500 mt-1">${r.name}</div>
        <button onclick="document.getElementById('profile-avatar-file').click()" class="mt-4 px-3 py-1.5 text-xs border border-ink-100 rounded-lg hover:bg-ink-50">更换头像</button>
        <input id="profile-avatar-file" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleProfileAvatarFile(this.files?.[0])" />
        <div id="profile-avatar-file-name" class="text-[10px] text-ink-400 mt-2">PNG / JPG / WebP · &lt;500KB</div>
      </div>

      <!-- 个人信息 -->
      <div class="col-span-2 card p-6">
        <h3 class="text-sm font-semibold text-ink-900 mb-4">个人信息</h3>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="text-xs text-ink-500">姓名</label>
            <input type="text" value="${r.user}" class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm" />
          </div>
          <div>
            <label class="text-xs text-ink-500">邮箱</label>
            <input type="email" value="${r.user}@easyshare.com" class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm" />
          </div>
          <div>
            <label class="text-xs text-ink-500">手机号</label>
            <input type="tel" placeholder="选填" class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm" />
          </div>
          <div>
            <label class="text-xs text-ink-500">界面语言</label>
            <select class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm bg-white">
              <option>简体中文</option>
              <option>English</option>
              <option>日本語</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-ink-500">时区</label>
            <select class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm bg-white">
              <option>UTC+8 北京时间</option>
              <option>UTC+0 GMT</option>
              <option>UTC-8 PST</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-ink-500">货币显示</label>
            <select class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm bg-white">
              <option>USD ($)</option>
              <option>CNY (¥)</option>
              <option>EUR (€)</option>
            </select>
          </div>
        </div>
        <div class="mt-6 pt-5 border-t border-ink-100 flex justify-end gap-2">
          <button class="px-4 py-2 border border-ink-100 rounded-lg text-sm hover:bg-ink-50">取消</button>
          <button onclick="confirmAction('保存修改', '确定要保存当前个人设置吗？保存后将立即生效。', '确认保存', '设置已保存')" class="px-4 py-2 bg-brand-500 text-white rounded-lg text-sm hover:bg-brand-600">保存修改</button>
        </div>
      </div>

      <!-- 通知偏好 -->
      <div class="col-span-3 card p-6">
        <h3 class="text-sm font-semibold text-ink-900 mb-4">通知偏好</h3>
        <div class="space-y-3">
          ${[
            { name: "SDK 新版本发布", desc: "重要更新与 Breaking Change 通知", email: true, in_app: true },
            { name: "数据异常预警", desc: "渠道转化率突然下降等异常", email: true, in_app: true },
            { name: "配置变更", desc: "我管理的游戏配置被修改", email: false, in_app: true },
            { name: "周报", desc: "每周一发送上周数据周报", email: true, in_app: false },
          ]
            .map(
              (n) => `
            <div class="flex items-center justify-between py-2 border-b border-ink-100 last:border-0">
              <div>
                <div class="text-sm font-medium">${n.name}</div>
                <div class="text-xs text-ink-500 mt-0.5">${n.desc}</div>
              </div>
              <div class="flex items-center gap-4 text-xs">
                <label class="flex items-center gap-1.5"><input type="checkbox" ${n.email ? "checked" : ""} class="w-4 h-4 rounded text-brand-500" /> 邮件</label>
                <label class="flex items-center gap-1.5"><input type="checkbox" ${n.in_app ? "checked" : ""} class="w-4 h-4 rounded text-brand-500" /> 站内信</label>
              </div>
            </div>
          `,
            )
            .join("")}
        </div>
      </div>
    </div>
  `;
};

function renderAdminOverviewModuleCard(item) {
  const icon = Icon[item.icon] ? Icon[item.icon]({ size: 16, color: item.color || "#1E3A8A" }) : "";
  return `
    <a href="#${item.path}" class="group rounded-xl border border-ink-100 bg-white p-4 hover:border-brand-200 hover:shadow-soft transition block">
      <div class="flex items-start justify-between gap-3">
        <div class="w-9 h-9 rounded-lg bg-ink-50 border border-ink-100 flex items-center justify-center group-hover:bg-brand-50">${icon}</div>
        ${item.badge ? `<span class="badge ${item.badgeTone || "bg-ink-100 text-ink-600"}">${item.badge}</span>` : ""}
      </div>
      <div class="text-sm font-semibold text-ink-900 mt-3">${item.title}</div>
      <div class="text-xs text-ink-500 mt-1 leading-5">${item.desc}</div>
      <div class="text-[11px] text-brand-700 mt-3 group-hover:underline">进入模块 →</div>
    </a>
  `;
}

Pages.adminOverview = function () {
  if (!UI.hasPerm("admin")) {
    return UI.emptyState({ icon: "🔒", title: "权限不足", desc: "管理员总览仅 SDK 管理员可访问" });
  }
  const modules = [
    {
      title: "平台接入与能力",
      desc: "SDK 版本、渠道能力、配置模型三条平台能力主线。",
      badge: "平台底座",
      items: [
        { icon: "package", title: "SDK 发布中心", desc: "发布、推荐、废弃和兼容性治理", path: "/admin/platform/sdk-releases", badge: "v2.4.0", badgeTone: "bg-brand-50 text-brand-700" },
        { icon: "globe", title: "渠道能力中心", desc: "维护渠道能力、Adapter、分享 Schema", path: "/admin/platform/channels", badge: `${MOCK.CHANNELS.length} 个渠道`, badgeTone: "bg-brand-50 text-brand-700" },
        { icon: "database", title: "配置模型治理", desc: "治理活动、卡片、落地页配置模型兼容性", path: "/admin/platform/config-schema", badge: "Schema", badgeTone: "bg-purple-50 text-purple-700" },
      ],
    },
    {
      title: "Share 全局参数",
      desc: "支撑包体、实验、分享活动、数据分析复用的统一参数口径。",
      badge: "全局口径",
      items: [
        { icon: "settings", title: "平台参数", desc: "归因、短链、缓存、数据归档等系统参数", path: "/admin/platform/settings", badge: "SLA", badgeTone: "bg-warn-50 text-warn-700" },
        { icon: "globe", title: "多语言配置", desc: "统一维护卡片和活动可选语种池", path: "/admin/platform/share-languages", badge: "BCP 47", badgeTone: "bg-ok-50 text-ok-700" },
        { icon: "globe", title: "区域国家配置", desc: "GLOBAL、10 大区域、ISO 国家码全局配置", path: "/admin/platform/regions-countries", badge: "10+1", badgeTone: "bg-ok-50 text-ok-700" },
      ],
    },
    {
      title: "游戏与安全治理",
      desc: "跨游戏治理、服务端凭证、人员权限和操作审计。",
      badge: "治理安全",
      items: [
        { icon: "gamepad", title: "游戏管理", desc: "跨游戏状态、接入完整度和高风险变更", path: "/admin/governance/games", badge: `${MOCK.GAMES.length} 款`, badgeTone: "bg-brand-50 text-brand-700" },
        { icon: "key", title: "凭证与密钥", desc: "OpenAPI Key、Game Secret、按申请重置与禁用", path: "/admin/security/credentials", badge: "重置", badgeTone: "bg-warn-50 text-warn-700" },
        { icon: "users", title: "用户与角色", desc: "SDK 管理员、研发、运营角色授权", path: "/admin/security/users", badge: `${MOCK.USERS.length} 人`, badgeTone: "bg-ink-100 text-ink-700" },
        { icon: "fileText", title: "审计日志", desc: "配置、密钥、权限等关键操作留痕", path: "/admin/security/audit-logs", badge: "180 天", badgeTone: "bg-ink-100 text-ink-700" },
      ],
    },
  ];
  const checks = [
    { label: "SDK 版本治理", value: "v2.4.0 推荐中", tone: "bg-brand-50 text-brand-700" },
    { label: "Share 全局参数", value: "区域/语言已统一", tone: "bg-ok-50 text-ok-700" },
    { label: "凭证安全", value: "按游戏方申请重置", tone: "bg-warn-50 text-warn-700" },
    { label: "平台健康", value: "99.95% 可用", tone: "bg-ok-50 text-ok-700" },
  ];
  return `
    ${UI.pageHeader({
      title: "管理员总览",
      desc: "围绕平台接入能力、Share 全局参数、游戏安全治理和平台观测，统一管理 EasyShare 的系统级能力。",
      actions: `<button onclick="navigate('/admin/platform/health')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">查看平台健康</button><button onclick="navigate('/admin/platform/settings')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">进入全局参数</button>`,
    })}

    <div class="grid grid-cols-4 gap-4 mb-5">
      ${renderExperimentAnalysisMetric("接入游戏", `${MOCK.GAMES.length} 款`, "GameID 统一", "游戏级唯一标识", "brand")}
      ${renderExperimentAnalysisMetric("接入包体", `${MOCK.PACKAGES.length} 个`, "Region × Platform", "包体级 App 信息", "blue")}
      ${renderExperimentAnalysisMetric("渠道能力", `${MOCK.CHANNELS.length} 个`, "Adapter", "分享渠道能力矩阵", "ok")}
      ${renderExperimentAnalysisMetric("安全治理", "4 项", "权限/密钥/审计", "管理员专属能力", "amber")}
    </div>

    <div class="card p-5 mb-5 bg-gradient-to-r from-brand-900 to-brand-700 text-white overflow-hidden relative">
      <div class="relative z-10 flex items-start justify-between gap-6">
        <div>
          <div class="text-xs opacity-75">Admin Information Architecture</div>
          <div class="text-xl font-semibold mt-1">管理员功能已按“平台能力 → 全局参数 → 治理安全 → 平台观测”重组</div>
          <div class="text-sm opacity-80 mt-2">管理员负责 EasyShare 产品级能力，不隶属于某一款游戏；游戏接入和运营配置通过研发/运营模块完成。</div>
        </div>
        <div class="grid grid-cols-2 gap-2 min-w-[360px]">
          ${checks.map((item) => `<div class="rounded-lg bg-white/10 border border-white/15 px-3 py-2"><div class="text-[11px] opacity-70">${item.label}</div><div class="text-sm font-semibold mt-1">${item.value}</div></div>`).join("")}
        </div>
      </div>
      <div class="absolute -right-12 -bottom-12 w-48 h-48 rounded-full bg-white/10"></div>
    </div>

    <div class="space-y-5">
      ${modules.map((group) => `
        <section class="card p-5">
          <div class="flex items-start justify-between gap-3 mb-4">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">${group.title}</h3>
              <p class="text-xs text-ink-500 mt-1">${group.desc}</p>
            </div>
            <span class="badge bg-ink-100 text-ink-600">${group.badge}</span>
          </div>
          <div class="grid grid-cols-${group.items.length >= 4 ? 4 : 3} gap-3">
            ${group.items.map(renderAdminOverviewModuleCard).join("")}
          </div>
        </section>
      `).join("")}

      <section class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
          <div>
            <h3 class="text-sm font-semibold text-ink-900">平台观测与待办</h3>
            <p class="text-xs text-ink-500 mt-0.5">把高风险项集中给 SDK 管理员，避免分散在具体游戏/运营配置中。</p>
          </div>
          <button onclick="navigate('/admin/platform/health')" class="px-3 py-1.5 text-xs border border-ink-100 rounded-lg hover:bg-ink-50">进入平台健康</button>
        </div>
        <div class="divide-y divide-ink-100">
          ${[
            ["渠道能力", "Discord Adapter 回调字段新增，需要同步配置模型", "今日", "bg-warn-50 text-warn-700"],
            ["密钥治理", "王者征途生产环境已发起 OpenAPI Key 重置申请，等待管理员确认", "待处理", "bg-warn-50 text-warn-700"],
            ["Share 参数", "区域国家配置已覆盖实验地区选择，建议复核 GLOBAL 默认策略", "本周", "bg-brand-50 text-brand-700"],
            ["审计", "近 24 小时 12 次配置模型变更，均已留痕", "正常", "bg-ok-50 text-ok-700"],
          ].map(([scope, desc, tag, tone]) => `
            <div class="px-5 py-3 flex items-center gap-4 text-sm">
              <span class="w-24 text-xs font-medium text-ink-500">${scope}</span>
              <span class="flex-1 text-ink-700">${desc}</span>
              <span class="badge ${tone}">${tag}</span>
            </div>
          `).join("")}
        </div>
      </section>
    </div>
  `;
};

Pages.settingsSystem = function () {
  if (!UI.hasPerm("admin")) {
    return UI.emptyState({ icon: "🔒", title: "权限不足", desc: "系统参数仅 SDK 管理员可调整" });
  }
  return `
    ${UI.pageHeader({
      title: "平台参数",
      desc: "统一维护 Share 全局口径：区域国家、多语言、归因、短链、缓存和数据归档。",
      actions: `<button onclick="navigate('/admin/overview')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回管理员总览</button><span class="text-xs text-amber-600 bg-amber-50 px-2 py-1 rounded">⚠️ 修改前请知会团队</span>`,
    })}

    <div class="space-y-4">
      <div class="grid grid-cols-3 gap-4">
        <div class="card p-5 bg-gradient-to-r from-brand-50 to-white border-brand-100">
          <div class="flex items-start justify-between gap-4">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">Share 区域国家配置</h3>
              <p class="text-xs text-ink-500 mt-1 leading-5">统一维护 GLOBAL 全球、10 大区域和 ISO 3166-1 国家/地区代码，供包体、实验、落地页和数据分析共用。</p>
            </div>
            <span class="badge bg-brand-900 text-white">10+1</span>
          </div>
          <button onclick="navigate('/admin/platform/regions-countries?return=/admin/platform/settings')" class="mt-4 px-3 py-2 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">进入配置</button>
        </div>
        <div class="card p-5 bg-gradient-to-r from-ok-50 to-white border-ok-100">
          <div class="flex items-start justify-between gap-4">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">Share 多语言配置</h3>
              <p class="text-xs text-ink-500 mt-1 leading-5">统一维护分享卡片、活动配置、实验配置可复用的语种池；管理员可扩展 BCP 47 语种。</p>
            </div>
            <span class="badge bg-ok-50 text-ok-700">BCP 47</span>
          </div>
          <button onclick="navigate('/admin/platform/share-languages?return=/admin/platform/settings')" class="mt-4 px-3 py-2 text-sm border border-ok-100 text-ok-700 rounded-lg hover:bg-ok-50">进入配置</button>
        </div>
        <div class="card p-5 bg-gradient-to-r from-warn-50 to-white border-warn-100">
          <div class="flex items-start justify-between gap-4">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">归因与链路参数</h3>
              <p class="text-xs text-ink-500 mt-1 leading-5">归因窗口、短链 SLA、缓存 TTL、数据归档共同决定 SDK 与数据链路的系统行为。</p>
            </div>
            <span class="badge bg-warn-50 text-warn-700">高风险</span>
          </div>
          <div class="mt-4 text-xs text-ink-500">下方参数保存后将同步到缓存与 SDK。</div>
        </div>
      </div>

      <!-- 归因 -->
      <div class="card p-6">
        <h3 class="text-sm font-semibold text-ink-900 mb-4">归因配置（Attribution）</h3>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="text-xs text-ink-500">默认归因窗口</label>
            <div class="flex items-center gap-2 mt-1">
              <input type="number" value="7" class="w-24 px-3 py-2 border border-ink-100 rounded-lg text-sm" />
              <span class="text-sm text-ink-500">天</span>
              <span class="text-xs text-ink-300">（用户点击后多久内安装算作有效归因）</span>
            </div>
          </div>
          <div>
            <label class="text-xs text-ink-500">设备指纹算法</label>
            <select class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm bg-white">
              <option>v2 · 增强模式（UA + IP + 屏幕分辨率 + 时区 + 系统语言）</option>
              <option>v1 · 基础模式</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-ink-500">指纹缓存 TTL</label>
            <div class="flex items-center gap-2 mt-1">
              <input type="number" value="7" class="w-24 px-3 py-2 border border-ink-100 rounded-lg text-sm" />
              <span class="text-sm text-ink-500">天</span>
            </div>
          </div>
          <div>
            <label class="text-xs text-ink-500">Deferred Deep Link 等待</label>
            <div class="flex items-center gap-2 mt-1">
              <input type="number" value="60" class="w-24 px-3 py-2 border border-ink-100 rounded-lg text-sm" />
              <span class="text-sm text-ink-500">秒</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 短链 -->
      <div class="card p-6">
        <h3 class="text-sm font-semibold text-ink-900 mb-4">短链服务</h3>
        <div class="space-y-4">
          <div>
            <label class="text-xs text-ink-500">短链域名</label>
            <div class="flex gap-2 mt-1">
              <input type="text" value="https://share.kqst.io" class="flex-1 px-3 py-2 border border-ink-100 rounded-lg text-sm font-mono" />
              <button class="px-3 py-2 border border-ink-100 rounded-lg text-sm hover:bg-ink-50">+ 添加自定义域名</button>
            </div>
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div>
              <label class="text-xs text-ink-500">默认有效期</label>
              <div class="flex items-center gap-2 mt-1"><input type="number" value="30" class="w-24 px-3 py-2 border border-ink-100 rounded-lg text-sm" /> <span class="text-sm">天</span></div>
            </div>
            <div>
              <label class="text-xs text-ink-500">ref_code 长度</label>
              <div class="flex items-center gap-2 mt-1"><input type="number" value="10" class="w-24 px-3 py-2 border border-ink-100 rounded-lg text-sm" /> <span class="text-sm">字符</span></div>
            </div>
            <div>
              <label class="text-xs text-ink-500">重定向延迟 SLA</label>
              <div class="flex items-center gap-2 mt-1"><input type="number" value="100" class="w-24 px-3 py-2 border border-ink-100 rounded-lg text-sm" /> <span class="text-sm">ms</span></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 缓存策略 -->
      <div class="card p-6">
        <h3 class="text-sm font-semibold text-ink-900 mb-4">缓存策略</h3>
        <div class="grid grid-cols-2 gap-4">
          ${[
            { key: "config:game:{game_id}", desc: "游戏级配置", ttl: "5 分钟", color: "brand" },
            { key: "config:package:{package_id}", desc: "包体级配置", ttl: "5 分钟", color: "brand" },
            { key: "channel:master:{channel_code}", desc: "渠道主数据", ttl: "1 小时", color: "blue" },
            { key: "fingerprint:{hash}", desc: "设备指纹", ttl: "7 天", color: "amber" },
            { key: "user:session:{sid}", desc: "用户会话", ttl: "24 小时", color: "green" },
            { key: "stats:funnel:{hash}", desc: "漏斗查询结果", ttl: "5 分钟", color: "rose" },
          ]
            .map(
              (c) => `
            <div class="flex items-center gap-3 p-3 bg-ink-50 rounded-lg">
              <code class="text-xs font-mono bg-white px-2 py-1 rounded text-ink-700">${c.key}</code>
              <div class="flex-1">
                <div class="text-xs text-ink-700">${c.desc}</div>
              </div>
              <span class="badge bg-${c.color}-50 text-${c.color}-700">${c.ttl}</span>
            </div>
          `,
            )
            .join("")}
        </div>
      </div>

      <!-- 数据归档 -->
      <div class="card p-6">
        <h3 class="text-sm font-semibold text-ink-900 mb-4">数据归档策略</h3>
        <div class="space-y-3">
          ${[
            { type: "原始事件 · 热数据", range: "0 - 30 天", storage: "ClickHouse SSD", color: "rose" },
            { type: "原始事件 · 温数据", range: "31 - 365 天", storage: "ClickHouse HDD（压缩）", color: "amber" },
            { type: "原始事件 · 冷数据", range: "> 365 天", storage: "对象存储 S3 / OSS", color: "blue" },
            { type: "聚合统计 · 每日", range: "永久保留", storage: "MySQL", color: "brand" },
            { type: "聚合统计 · 每小时", range: "保留 90 天", storage: "MySQL", color: "brand" },
            { type: "操作日志", range: "保留 180 天（合规要求）", storage: "MySQL", color: "green" },
          ]
            .map(
              (a) => `
            <div class="flex items-center gap-3 py-2 border-b border-ink-100 last:border-0">
              <div class="w-2 h-2 rounded-full bg-${a.color}-500"></div>
              <div class="flex-1">
                <div class="text-sm">${a.type}</div>
              </div>
              <div class="text-xs text-ink-500">${a.range}</div>
              <code class="text-[10px] font-mono px-2 py-0.5 bg-ink-50 rounded">${a.storage}</code>
            </div>
          `,
            )
            .join("")}
        </div>
      </div>

      <div class="flex justify-end gap-2">
        <button class="px-4 py-2 border border-ink-100 rounded-lg text-sm hover:bg-ink-50">取消</button>
        <button onclick="confirmAction('保存系统参数', '确定要保存全部系统参数吗？部分配置会在 5 分钟内同步到缓存与 SDK。', '确认保存', '系统参数已保存，5 分钟内生效')" class="px-4 py-2 bg-brand-500 text-white rounded-lg text-sm hover:bg-brand-600">保存全部修改</button>
      </div>
    </div>
  `;
};

function getShareRegionCountrySelection() {
  const initial = { global: true, regions: ["GLOBAL"], countries: [] };
  const saved = window.__shareRegionCountrySelection || initial;
  return {
    global: Boolean(saved.global || saved.regions?.includes("GLOBAL")),
    regions: Array.from(new Set(saved.regions || initial.regions)),
    countries: Array.from(new Set(saved.countries || [])),
  };
}

function setShareRegionCountrySelection(selection) {
  window.__shareRegionCountrySelection = {
    global: Boolean(selection.global),
    regions: Array.from(new Set(selection.regions || [])),
    countries: Array.from(new Set(selection.countries || [])),
  };
}

function getShareRegionByCode(code) {
  if (code === "GLOBAL") return window.SHARE_GLOBAL_REGION || { code: "GLOBAL", name: "Global", zhName: "全球" };
  const groups = typeof window.getShareRegionCountryGroups === "function" ? window.getShareRegionCountryGroups() : [];
  return groups.find((region) => region.code === code);
}

function renderShareRegionCountrySummary(selection = getShareRegionCountrySelection()) {
  if (selection.global) {
    return `<span class="badge bg-brand-900 text-white">GLOBAL · 全球</span><span class="text-xs text-ink-500">覆盖所有区域和国家，无需再选择单个国家。</span>`;
  }
  const regionChips = selection.regions.filter((code) => code !== "GLOBAL").map((code) => {
    const region = getShareRegionByCode(code);
    return `<span class="badge bg-brand-50 text-brand-700">${code} · ${region?.zhName || region?.name || code}</span>`;
  }).join("");
  const countryOptions = typeof window.getShareCountryOptions === "function" ? window.getShareCountryOptions() : [];
  const countryMap = new Map(countryOptions.map((country) => [country.code, country]));
  const countryChips = selection.countries.slice(0, 16).map((code) => {
    const country = countryMap.get(code);
    return `<span class="badge bg-ink-100 text-ink-700">${code} · ${country?.name || country?.zhName || code}</span>`;
  }).join("");
  const more = selection.countries.length > 16 ? `<span class="badge bg-ink-50 text-ink-500">+${selection.countries.length - 16}</span>` : "";
  return regionChips || countryChips ? `${regionChips}${countryChips}${more}` : `<span class="text-xs text-ink-400">尚未选择，保存时将默认 GLOBAL 全球。</span>`;
}

function getShareRegionCountryPickerContext(scope) {
  if (scope !== "experiment-region") return null;
  try {
    const context = JSON.parse(sessionStorage.getItem("easyshare:regionCountryPickerContext") || "null");
    return context?.scope === scope ? context : null;
  } catch (e) {
    return null;
  }
}

function filterShareRegionCountryByContext(regions, countries, context) {
  if (!context) return { regions, countries, scoped: false };
  const allowedRegionCodes = new Set(context.allowedRegionCodes || []);
  const allowedCountryCodes = new Set(context.allowedCountryCodes || []);
  if (allowedRegionCodes.has("GLOBAL") || (!allowedRegionCodes.size && !allowedCountryCodes.size)) {
    return { regions, countries, scoped: Boolean(context) };
  }
  const visibleRegions = regions.map((region) => {
    const regionCovered = allowedRegionCodes.has(region.code);
    const regionCountries = regionCovered
      ? region.countries
      : region.countries.filter((country) => allowedCountryCodes.has(country.code));
    return regionCountries.length ? { ...region, countries: regionCountries } : null;
  }).filter(Boolean);
  const visibleCountries = visibleRegions.flatMap((region) => region.countries.map((country) => ({ ...country, regionName: region.name, regionZhName: region.zhName })));
  return { regions: visibleRegions, countries: visibleCountries, scoped: true };
}

function escapeRegionCountryValue(value) {
  return String(value || "").replace(/[&<>"']/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch]));
}

function getShareRegionCountryViewMode() {
  return window.__shareRegionCountryViewMode || "region";
}

function getShareRegionCountrySearchKeyword() {
  return (window.__shareRegionCountrySearchKeyword || "").trim();
}

function normalizeRegionCountrySearchText(value) {
  return String(value || "").toLowerCase().replace(/[\s·/／\-_,，.。()（）&]+/g, "");
}

function matchShareRegionCountry(item, keyword) {
  if (!keyword) return true;
  const q = normalizeRegionCountrySearchText(keyword);
  return [item.code, item.name, item.zhName, item.regionCode, item.regionName, item.regionZhName]
    .filter(Boolean)
    .some((text) => normalizeRegionCountrySearchText(text).includes(q));
}

function renderShareCountryCheckbox(country, selection) {
  const checked = !selection.global && (selection.countries || []).includes(country.code);
  return `
    <label class="rounded-lg border ${checked ? "border-brand-300 bg-brand-50" : "border-ink-100 bg-white hover:border-brand-200 hover:bg-brand-50/20"} px-3 py-2 cursor-pointer transition">
      <div class="flex items-start gap-2">
        <input type="checkbox" ${checked ? "checked" : ""} onchange="toggleShareCountrySelection('${country.code}', this.checked)" class="mt-0.5 rounded border-ink-300" />
        <span class="min-w-0">
          <span class="block text-xs font-semibold text-ink-900">${country.code} · ${country.name}</span>
          <span class="block text-[11px] text-ink-400 truncate">${country.zhName}${country.regionCode ? ` · ${country.regionCode}` : ""}</span>
        </span>
      </div>
    </label>
  `;
}

function renderShareRegionGroupedPicker(regions, selection, keyword) {
  const selectedRegions = new Set(selection.regions || []);
  const selectedCountries = new Set(selection.countries || []);
  const rows = regions.map((region) => {
    const regionMatched = matchShareRegionCountry(region, keyword);
    const matchedCountries = region.countries.filter((country) => matchShareRegionCountry({ ...country, regionName: region.name, regionZhName: region.zhName }, keyword));
    const countries = keyword && !regionMatched ? matchedCountries : region.countries;
    if (keyword && !regionMatched && !matchedCountries.length) return "";
    const regionChecked = !selection.global && selectedRegions.has(region.code);
    const selectedCount = region.countries.filter((country) => selectedCountries.has(country.code)).length;
    return `
      <details class="rounded-2xl border ${regionChecked || selectedCount ? "border-brand-200 bg-brand-50/30" : "border-ink-100 bg-white"} overflow-hidden" ${keyword || regionChecked || selectedCount ? "open" : ""}>
        <summary class="px-4 py-3 cursor-pointer hover:bg-ink-50 flex items-center justify-between gap-3">
          <div class="flex items-center gap-3 min-w-0">
            <input type="checkbox" ${regionChecked ? "checked" : ""} onclick="event.stopPropagation()" onchange="toggleShareRegionSelection('${region.code}', this.checked)" class="rounded border-ink-300" />
            <div class="min-w-0">
              <div class="text-sm font-semibold text-ink-900">${region.code} · ${region.zhName}</div>
              <div class="text-xs text-ink-400 truncate">${region.name}</div>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <span class="badge bg-ink-100 text-ink-700">${selectedCount}/${region.countries.length}</span>
            <span class="text-xs text-ink-400 group-open:rotate-180 transition-transform">⌄</span>
          </div>
        </summary>
        <div class="px-4 pb-4">
          <div class="mb-3 flex items-center justify-between gap-2 text-xs">
            <span class="text-ink-500">${keyword ? `匹配 ${countries.length} 个国家/地区` : "可直接选择整个区域，也可精细选择国家"}</span>
            <div class="flex items-center gap-3">
              <button type="button" onclick="selectShareRegionCountries('${region.code}')" class="text-brand-700 hover:underline">全选国家</button>
              <button type="button" onclick="clearShareRegionCountries('${region.code}')" class="text-ink-500 hover:underline">清空该区域</button>
            </div>
          </div>
          <div class="grid grid-cols-2 lg:grid-cols-3 gap-2">
            ${countries.map((country) => renderShareCountryCheckbox({ ...country, regionName: region.name, regionZhName: region.zhName }, selection)).join("")}
          </div>
        </div>
      </details>
    `;
  }).join("");
  return rows || `<div class="rounded-xl border border-dashed border-ink-200 bg-ink-50 p-8 text-center text-sm text-ink-400">未找到匹配的区域或国家</div>`;
}

function renderShareAlphabetGroupedPicker(countries, selection, keyword) {
  const filtered = countries
    .filter((country) => matchShareRegionCountry(country, keyword))
    .sort((a, b) => String(a.name || a.code).localeCompare(String(b.name || b.code)));
  if (!filtered.length) return `<div class="rounded-xl border border-dashed border-ink-200 bg-ink-50 p-8 text-center text-sm text-ink-400">未找到匹配的国家/地区</div>`;
  const groups = filtered.reduce((map, country) => {
    const letter = /^[A-Z]/.test(String(country.name || "").charAt(0).toUpperCase()) ? String(country.name).charAt(0).toUpperCase() : "#";
    map[letter] = map[letter] || [];
    map[letter].push(country);
    return map;
  }, {});
  return Object.keys(groups).sort().map((letter) => `
    <section class="rounded-2xl border border-ink-100 bg-white overflow-hidden">
      <div class="px-4 py-2.5 bg-ink-50 border-b border-ink-100 flex items-center justify-between">
        <span class="text-sm font-semibold text-ink-900">${letter}</span>
        <span class="text-xs text-ink-400">${groups[letter].length} 个</span>
      </div>
      <div class="p-4 grid grid-cols-2 lg:grid-cols-3 gap-2">
        ${groups[letter].map((country) => renderShareCountryCheckbox(country, selection)).join("")}
      </div>
    </section>
  `).join("");
}

Pages.regionCountrySettings = function () {
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const params = new URLSearchParams(query);
  const scope = params.get("scope") || "";
  const isAdminManage = (typeof getCurrentPath === "function" ? getCurrentPath() : "") === "/admin/platform/regions-countries" && !params.has("return");
  const returnPath = params.get("return") || "/admin/platform/settings";
  const allRegions = typeof window.getShareRegionCountryGroups === "function" ? window.getShareRegionCountryGroups() : [];
  const allCountries = typeof window.getShareCountryOptions === "function" ? window.getShareCountryOptions() : [];
  const pickerContext = getShareRegionCountryPickerContext(scope);
  const filtered = filterShareRegionCountryByContext(allRegions, allCountries, pickerContext);
  const regions = filtered.regions;
  const countries = filtered.countries;
  const selection = getShareRegionCountrySelection();
  const selectedRegions = new Set(selection.regions || []);
  const selectedCountries = new Set(selection.countries || []);
  const mode = pickerContext ? "alphabet" : getShareRegionCountryViewMode();
  const keyword = getShareRegionCountrySearchKeyword();
  return `
    ${UI.pageHeader({
      title: pickerContext ? "实验地区选择" : "区域国家配置",
      desc: pickerContext ? "仅展示上一步已选包体对应的地区；确认后回到创建实验组继续配置。" : (isAdminManage ? "管理员维护 Share 系统全局区域和国家口径，供包体、实验、落地页和数据分析统一复用。" : "为当前业务配置选择适用区域和国家；确认后回到来源页面继续配置。"),
      actions: `
        <span class="badge ${isAdminManage ? "bg-purple-50 text-purple-700" : "bg-brand-50 text-brand-700"}">${pickerContext ? "实验地区选择" : (isAdminManage ? "管理员全局管理" : "业务选择模式")}</span>
        <button onclick="navigate('${returnPath}')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">${isAdminManage ? "返回平台参数" : "取消返回"}</button>
        <button onclick="saveShareRegionCountrySettings('${returnPath}')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">${isAdminManage ? "保存全局区域配置" : (pickerContext ? "确认实验地区" : "确认选择并返回")}</button>
      `,
    })}

    <div class="grid grid-cols-12 gap-5 items-start">
      <section class="col-span-12 xl:col-span-8 space-y-5">
        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100 bg-gradient-to-r from-brand-50 to-white">
            <div class="flex items-center justify-between gap-4">
              <div>
                <h3 class="text-sm font-semibold text-ink-900">${pickerContext ? "可选实验地区" : (isAdminManage ? "全局区域国家池" : "选择区域 / 国家")}</h3>
                <p class="text-xs text-ink-500 mt-0.5">${pickerContext ? `来自 ${pickerContext.packageCount || 0} 个包体的地区范围，避免选择未覆盖包体的地区。` : (isAdminManage ? "维护系统统一区域国家口径；业务入口只做选择，不修改口径。" : "支持按区域、按国家首字母排列选择，也可以直接搜索国家名、中文名或 ISO 代码。")}</p>
              </div>
              <span class="badge bg-brand-50 text-brand-700">${pickerContext ? "已筛选" : "GLOBAL"} + ${regions.length} 区域 · ${countries.length} 国家/地区</span>
            </div>
          </div>
          <div class="p-5 space-y-4">
            ${pickerContext ? `<div class="rounded-xl border border-brand-100 bg-brand-50 px-4 py-3 text-xs text-brand-800 leading-relaxed">当前已按上一步包体过滤地区范围：${(pickerContext.packageNames || []).slice(0, 3).join("、") || "已选包体"}${(pickerContext.packageNames || []).length > 3 ? ` 等 ${pickerContext.packageNames.length} 个` : ""}</div>` : `<label class="block rounded-xl border ${selection.global ? "border-brand-300 bg-brand-50" : "border-ink-100 bg-white hover:border-brand-200"} px-4 py-3 cursor-pointer">
              <div class="flex items-start gap-3">
                <input type="checkbox" ${selection.global ? "checked" : ""} onchange="toggleShareGlobalRegion(this.checked)" class="mt-1 rounded border-ink-300" />
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 flex-wrap">
                    <span class="text-sm font-semibold text-ink-900">GLOBAL · 全球</span>
                    <span class="badge bg-brand-900 text-white">默认不限制</span>
                  </div>
                  <p class="text-xs text-ink-500 mt-1">选中后覆盖所有区域和国家；如需精细选择，请取消 GLOBAL。</p>
                </div>
              </div>
            </label>`}

            <div class="rounded-2xl border border-ink-100 bg-ink-50/50 p-3 space-y-3">
              <div class="flex flex-col lg:flex-row lg:items-center gap-3">
                <div class="flex rounded-xl border border-ink-100 bg-white p-1 w-fit">
                  <button type="button" onclick="setShareRegionCountryViewMode('region')" class="px-3 py-1.5 text-xs rounded-lg ${mode === "region" ? "bg-brand-900 text-white" : "text-ink-600 hover:bg-ink-50"}">按区域排列</button>
                  <button type="button" onclick="setShareRegionCountryViewMode('alphabet')" class="px-3 py-1.5 text-xs rounded-lg ${mode === "alphabet" ? "bg-brand-900 text-white" : "text-ink-600 hover:bg-ink-50"}">按国家首字母</button>
                </div>
                <div class="flex-1 flex items-center gap-2">
                  <input id="share-region-country-search" value="${escapeRegionCountryValue(keyword)}" oncompositionstart="window.__shareRegionCountryComposing = true" oncompositionend="window.__shareRegionCountryComposing = false; setShareRegionCountrySearch(this.value, true)" oninput="setShareRegionCountrySearch(this.value)" placeholder="搜索国家/地区、区域、ISO 代码，如 US / 美国 / North America" class="w-full px-3 py-2 border border-ink-200 rounded-lg bg-white text-sm outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100" />
                  ${keyword ? `<button type="button" onclick="clearShareRegionCountrySearch()" class="px-3 py-2 text-xs rounded-lg border border-ink-100 bg-white hover:bg-ink-50">清空</button>` : ""}
                </div>
              </div>
              <div class="text-xs text-ink-500">${keyword ? `搜索中：${escapeRegionCountryValue(keyword)}` : "提示：区域级选择用于快速覆盖市场，国家级选择用于更精细的投放和报表口径。"}</div>
            </div>

            <div class="space-y-3">
              ${mode === "alphabet" ? renderShareAlphabetGroupedPicker(countries, selection, keyword) : renderShareRegionGroupedPicker(regions, selection, keyword)}
            </div>
          </div>
        </div>
      </section>

      <aside class="col-span-12 xl:col-span-4 space-y-5 sticky top-4">
        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100">
            <h3 class="text-sm font-semibold text-ink-900">当前选择</h3>
            <p class="text-xs text-ink-500 mt-0.5">${isAdminManage ? "保存后作为 Share 系统统一区域国家配置。" : (pickerContext ? "确认后作为当前实验组的地区生效范围。" : "确认后应用到当前业务配置。")}</p>
          </div>
          <div class="p-5 space-y-4">
            <div class="grid grid-cols-3 gap-3 text-center">
              <div class="rounded-xl bg-brand-50 p-3">
                <div class="text-lg font-bold text-brand-900">${selection.global ? 1 : selectedRegions.size}</div>
                <div class="text-[11px] text-brand-700">区域</div>
              </div>
              <div class="rounded-xl bg-ink-50 p-3">
                <div class="text-lg font-bold text-ink-900">${selection.global ? countries.length : selectedCountries.size}</div>
                <div class="text-[11px] text-ink-500">国家/地区</div>
              </div>
              <div class="rounded-xl bg-ok-50 p-3">
                <div class="text-lg font-bold text-ok-700">ISO</div>
                <div class="text-[11px] text-ok-700">3166-1</div>
              </div>
            </div>
            <div class="rounded-xl border border-ink-100 bg-ink-50/60 p-3 flex flex-wrap gap-2">
              ${renderShareRegionCountrySummary(selection)}
            </div>
            <div class="flex gap-2">
              <button type="button" onclick="clearShareRegionCountrySelection()" class="flex-1 px-3 py-2 text-xs rounded-lg border border-ink-100 bg-white hover:bg-ink-50">清空选择</button>
              <button type="button" onclick="toggleShareGlobalRegion(true)" class="flex-1 px-3 py-2 text-xs rounded-lg bg-brand-50 text-brand-700 hover:bg-brand-100">恢复 GLOBAL</button>
            </div>
          </div>
        </div>

        <div class="card p-4 ${isAdminManage ? "bg-amber-50 border-amber-200" : "bg-brand-50 border-brand-200"}">
          <div class="text-sm font-semibold ${isAdminManage ? "text-amber-900" : "text-brand-900"}">${isAdminManage ? "全局管理说明" : "业务选择说明"}</div>
          <div class="mt-1 text-xs ${isAdminManage ? "text-amber-800" : "text-brand-800"} leading-relaxed">${pickerContext ? "本次只允许选择上一步包体覆盖到的地区，避免实验生效范围和包体范围不一致。" : (isAdminManage ? "管理员维护统一的区域和国家口径；包体 Region、实验生效地区、落地页受众区域、数据分析国家维度等入口复用这里。" : "这里只选择当前业务需要覆盖的区域和国家；如缺少区域或国家，请联系管理员维护全局口径。")}</div>
        </div>
      </aside>
    </div>
  `;
};

window.setShareRegionCountryViewMode = function (mode) {
  window.__shareRegionCountryViewMode = mode === "alphabet" ? "alphabet" : "region";
  renderRoute();
};

window.setShareRegionCountrySearch = function (keyword, force = false) {
  window.__shareRegionCountrySearchKeyword = keyword || "";
  clearTimeout(window.__shareRegionCountrySearchTimer);
  if (window.__shareRegionCountryComposing && !force) return;
  window.__shareRegionCountrySearchTimer = setTimeout(() => renderRoute(), force ? 0 : 180);
};

window.clearShareRegionCountrySearch = function () {
  window.__shareRegionCountrySearchKeyword = "";
  renderRoute();
};

window.toggleShareGlobalRegion = function (checked) {
  if (checked) {
    setShareRegionCountrySelection({ global: true, regions: ["GLOBAL"], countries: [] });
  } else {
    setShareRegionCountrySelection({ global: false, regions: [], countries: [] });
  }
  renderRoute();
};

window.toggleShareRegionSelection = function (regionCode, checked) {
  const selection = getShareRegionCountrySelection();
  const region = getShareRegionByCode(regionCode);
  const regionCountryCodes = new Set((region?.countries || []).map((country) => country.code));
  const regions = new Set(selection.regions.filter((code) => code !== "GLOBAL"));
  const countries = new Set(selection.countries || []);
  if (checked) {
    regions.add(regionCode);
    regionCountryCodes.forEach((code) => countries.add(code));
  } else {
    regions.delete(regionCode);
    regionCountryCodes.forEach((code) => countries.delete(code));
  }
  setShareRegionCountrySelection({ global: false, regions: Array.from(regions), countries: Array.from(countries) });
  renderRoute();
};

window.toggleShareCountrySelection = function (countryCode, checked) {
  const selection = getShareRegionCountrySelection();
  const countries = new Set(selection.countries);
  if (checked) countries.add(countryCode); else countries.delete(countryCode);
  setShareRegionCountrySelection({ global: false, regions: selection.regions.filter((code) => code !== "GLOBAL"), countries: Array.from(countries) });
  renderRoute();
};

window.selectShareRegionCountries = function (regionCode) {
  const selection = getShareRegionCountrySelection();
  const region = getShareRegionByCode(regionCode);
  const countries = new Set(selection.countries);
  (region?.countries || []).forEach((country) => countries.add(country.code));
  const regions = new Set(selection.regions.filter((code) => code !== "GLOBAL"));
  regions.add(regionCode);
  setShareRegionCountrySelection({ global: false, regions: Array.from(regions), countries: Array.from(countries) });
  renderRoute();
};

window.clearShareRegionCountries = function (regionCode) {
  const selection = getShareRegionCountrySelection();
  const region = getShareRegionByCode(regionCode);
  const removeCodes = new Set((region?.countries || []).map((country) => country.code));
  const countries = (selection.countries || []).filter((code) => !removeCodes.has(code));
  const regions = (selection.regions || []).filter((code) => code !== "GLOBAL" && code !== regionCode);
  setShareRegionCountrySelection({ global: false, regions, countries });
  renderRoute();
};

window.clearShareRegionCountrySelection = function () {
  setShareRegionCountrySelection({ global: false, regions: [], countries: [] });
  renderRoute();
};

window.saveShareRegionCountrySettings = async function (returnPath = "/admin/platform/settings") {
  const selection = getShareRegionCountrySelection();
  if (!selection.global && !selection.regions.length && !selection.countries.length) {
    setShareRegionCountrySelection({ global: true, regions: ["GLOBAL"], countries: [] });
  }
  const next = getShareRegionCountrySelection();
  try {
    await contentApi.updateRegions(next);
    await invalidateAndRefresh();
    const isAdminReturn = String(returnPath || "").startsWith("/admin/");
    UI.toast(isAdminReturn ? "Share 区域国家配置已保存" : "区域国家选择已确认", "success");
    navigate(returnPath);
  } catch (err) {
    UI.toast(err?.message || "保存失败", "error");
  }
};

Pages.settingsApiKeys = function () {
  if (!UI.hasPerm("admin")) {
    return UI.emptyState({ icon: "🔒", title: "权限不足", desc: "凭证与密钥仅 SDK 管理员可访问" });
  }

  const activeGames = MOCK.GAMES.filter((g) => g.status === "active" || g.status === "stable");
  const resetRequests = [
    { game: "王者征途", type: "Game Secret", reason: "游戏方发起生产环境密钥重置申请", requester: "王工", time: "2026-07-02 10:20", status: "待确认" },
    { game: "梦幻西游 Global", type: "OpenAPI Key", reason: "测试环境密钥疑似泄露，申请重置", requester: "李四", time: "2026-07-01 18:40", status: "处理中" },
  ];
  // OpenAPI Key 只有两种固定用途口径：事件上报密钥（events:write）与数据读取密钥（analytics:read / config:read），直接以此命名展示，不再用自定义名称
  const openApiKeys = [
    { name: "事件上报密钥", key: "es_evt_8a2f9c1b3d4e5f6a7b8c9d0e1f2a3b4c", perm: "events:write", game: "王者征途", env: "Production", lastUsed: "2 分钟前", owner: "王工", status: "active" },
    { name: "数据读取密钥", key: "es_rd_9f3d8a5b1c2d3e4f5a6b7c8d9e0f1a2b", perm: "analytics:read, config:read", game: "王者征途", env: "Production", lastUsed: "15 分钟前", owner: "王工", status: "active" },
    { name: "事件上报密钥", key: "es_evt_4c1e7a2b9f3d8a5b6c7d8e9f0a1b2c3d", perm: "events:write", game: "梦幻西游 Global", env: "Test", lastUsed: "1 小时前", owner: "赵六", status: "active" },
    { name: "数据读取密钥", key: "es_rd_1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f", perm: "analytics:read, config:read", game: "梦幻西游 Global", env: "Test", lastUsed: "3 小时前", owner: "赵六", status: "active" },
    { name: "数据读取密钥", key: "es_rd_7e9a21c8d0f4b6a2c3d4e5f6a7b8c9d0", perm: "analytics:read", game: "Match Hero", env: "Production", lastUsed: "昨天", owner: "张三", status: "active" },
    { name: "废弃 · 内测脚本", key: "es_old_0000111122223333444455556666", perm: "—", game: "—", env: "Legacy", lastUsed: "3 个月前", owner: "李管理", status: "inactive" },
  ];
  const credentialTypes = [
    { name: "GameID", level: "游戏级", sensitivity: "公开标识", owner: "系统生成", usage: "SDK 初始化、API 归属、数据归集", policy: "同一游戏唯一，不按包体拆分" },
    { name: "Game Secret", level: "游戏级", sensitivity: "高敏密钥", owner: "SDK 管理员治理", usage: "服务端签名、后台通信根密钥", policy: "仅创建后展示一次；按游戏方申请重置" },
    { name: "Ripple ID", level: "包体级", sensitivity: "公开标识", owner: "系统生成", usage: "区分 Region × Platform 包体", policy: "包体唯一，不生成独立 Secret" },
    { name: "Bundle ID / App ID / Store URL", level: "包体级", sensitivity: "平台接入信息", owner: "游戏研发维护", usage: "商店跳转、平台识别、归因匹配", policy: "随包体维护，可编辑留痕" },
    { name: "OpenAPI Key / App Key", level: "服务端接入", sensitivity: "敏感密钥", owner: "SDK 管理员创建 / 禁用", usage: "事件上报、配置读取、数据读取", policy: "新密钥仅展示一次；支持按申请重置" },
    { name: "Webhook URL", level: "游戏服务端", sensitivity: "接入地址", owner: "游戏研发维护", usage: "分享、归因、付费事件回调", policy: "当前为 URL 管理，后续可补充签名密钥" },
  ];
  const auditLogs = [
    { time: "2026-07-02 11:05", user: "李管理", action: "确认 Game Secret 重置申请", target: "王者征途", result: "待执行" },
    { time: "2026-07-01 19:02", user: "李管理", action: "禁用 OpenAPI Key", target: "废弃 · 内测脚本", result: "成功" },
    { time: "2026-06-30 16:18", user: "李管理", action: "创建 OpenAPI Key", target: "Match Hero 数据分析", result: "成功" },
  ];

  const secretPreview = (game) => `gs_live_${game.id.replace(/[^a-z0-9]/gi, "").padEnd(16, "0")}a1b2c3d4e5f6a7b8`;
  const secretAction = (game) => `UI.confirmModal({title:'重置 Game Secret',content:'仅当游戏方明确发起重置申请时执行。确认要为 <strong>${game.name}</strong> 重置 Game Secret 吗？重置后该游戏下所有包体服务端部署都需要同步更新。',confirmText:'确认重置',onConfirm:()=>UI.toast('已生成新 Game Secret，请安全交付给游戏方','warning')})`;
  const apiKeyAction = (name, action) => `confirmAction('${action} OpenAPI Key', '确认${action}「${name}」？该操作会写入审计日志。', '确认${action}', '已${action} OpenAPI Key', '', 'warning')`;
  // 待处理重置申请的行级操作：确认（执行重置并写入审计日志）/ 驳回（通知申请人）
  const resetRequestAction = (item, action) => {
    const isReject = action === "驳回";
    const content = isReject
      ? `确定驳回 <strong>${item.game}</strong> 的 <strong>${item.type}</strong> 重置申请吗？申请人 ${item.requester} 将收到驳回通知，该操作会写入审计日志。`
      : `确认已核实并同意 <strong>${item.game}</strong> 的 <strong>${item.type}</strong> 重置申请？确认后将执行重置并写入审计日志，请提前准备好向游戏方安全交付新密钥。`;
    return `UI.confirmModal({title:'${action}重置申请',content:'${content}',confirmText:'确认${action}',onConfirm:()=>UI.toast('已${action}「${item.game} · ${item.type}」重置申请','${isReject ? "info" : "success"}')})`;
  };

  // 按权限拆解 OpenAPI Key 的用途类型：事件上报 / 数据读取 / 配置读取；不使用气泡包裹，纯文字以颜色区分并用分隔符连接
  const PERM_META = {
    "events:write": { label: "事件上报", color: "text-brand-700" },
    "analytics:read": { label: "数据读取", color: "text-ok-700" },
    "config:read": { label: "配置读取", color: "text-ink-700" },
  };
  const permBadges = (perm) => {
    if (!perm || perm === "—") return `<span class="text-ink-400">—</span>`;
    return perm.split(",").map((p) => {
      const key = p.trim();
      const meta = PERM_META[key] || { label: key, color: "text-ink-700" };
      return `<span class="${meta.color} font-medium whitespace-nowrap">${meta.label}</span>`;
    }).join(`<span class="text-ink-300 mx-1">·</span>`);
  };
  // OpenAPI Key 状态：不使用气泡/色点，直接以颜色区分文字
  const OPENAPI_STATUS_META = {
    active: { text: "运行中", color: "text-ok-700" },
    inactive: { text: "已停用", color: "text-ink-400" },
  };
  const plainStatus = (status) => {
    const m = OPENAPI_STATUS_META[status] || { text: status, color: "text-ink-600" };
    return `<span class="${m.color} text-xs font-medium">${m.text}</span>`;
  };

  // 统一的凭证展示原子组件：游戏头像、只读密钥 chip、绑定 Key chip、包体 chip —— 保证两张表格视觉口径一致、行高整齐
  const gameAvatar = (game) => `
    <div class="flex items-center gap-2.5">
      <span class="w-8 h-8 rounded-lg bg-ink-50 border border-ink-100 flex items-center justify-center text-base shrink-0">${game.icon}</span>
      <span class="font-semibold text-ink-900 whitespace-nowrap">${game.name}</span>
    </div>`;
  const CODE_TONE = {
    brand: "text-brand-700",
    warn: "text-warn-700",
    ink: "text-ink-600",
  };
  // 不使用气泡（背景/边框/圆角）包裹，直接以纯文字形式展示；密钥/标识始终完整展示，不隐藏、不省略、不折行、不截断
  // wrap=true：允许 break-all 在列宽内自动换行，完整显示（适合 GameID/Bundle ID 等标识）
  // wrap=false：单行不折行展示（如 Game Secret），列宽不够时通过 overflow-x-auto 横向滚动查看完整内容，保留细滚动条提示可滚动，而非用 truncate/ellipsis 省略
  const codeChip = (text, tone = "ink", wrap = true, copyLabel = "") => `
    <div class="flex items-start gap-1.5 max-w-full min-w-0">
      <code class="font-mono text-xs ${CODE_TONE[tone] || CODE_TONE.ink} block leading-relaxed min-w-0 ${wrap ? "max-w-full break-all" : "max-w-full whitespace-nowrap overflow-x-auto cred-scroll"}">${text}</code>
      ${copyLabel ? `<button onclick="copyText('${text}', '${copyLabel} ')" class="shrink-0 text-ink-400 hover:text-brand-700 mt-0.5" title="复制${copyLabel}">${Icon.copy({ size: 12, color: "currentColor", stroke: 2 })}</button>` : ""}
    </div>`;
  // 列头已表明用途（事件上报密钥/数据读取密钥），格子内直接展示密钥本身即可，不再重复展示字段名；不使用气泡/色点包裹，纯文字展示，用文字颜色区分启用/停用
  const keyChip = (k) => {
    const color = k.status === "inactive" ? "text-ink-400" : "text-ink-700";
    return `
      <div class="mb-1.5 max-w-full min-w-0" title="${k.name}">
        <code class="text-[11px] font-mono ${color} whitespace-nowrap overflow-x-auto cred-scroll leading-relaxed min-w-0 block">${k.key}</code>
      </div>`;
  };
  const chipWrap = (items, emptyText) => items.length ? `<div class="flex flex-col max-w-full">${items.join("")}</div>` : `<span class="text-ink-400 text-xs">${emptyText}</span>`;

  return `
    ${UI.pageHeader({
      title: "凭证与密钥",
      desc: "管理员统一治理游戏级凭证、服务端 OpenAPI Key、重置申请、禁用状态与审计留痕。",
      actions: `<button onclick="confirmAction('创建 OpenAPI Key', '新密钥仅展示一次，请确认已准备安全保存位置。', '确认创建', '已生成新 OpenAPI Key，请立即复制保存')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">+ 创建 OpenAPI Key</button>`,
    })}

    ${resetRequests.length ? `
    <section class="card overflow-hidden mb-5">
      <div class="px-5 py-3 border-b border-ink-100 flex items-center gap-2">
        <span class="text-warn-700">${Icon.alert({ size: 15, color: "#B45309" })}</span>
        <h3 class="text-sm font-semibold text-ink-900">待处理重置申请</h3>
        <span class="text-warn-700 text-xs font-medium">${resetRequests.length}</span>
      </div>
      <table class="w-full text-sm">
        <tbody>
          ${resetRequests.map((item) => `
            <tr class="border-t border-ink-100 first:border-t-0 row-hover">
              <td class="px-5 py-2.5 whitespace-nowrap align-top"><span class="font-medium text-ink-900">${item.game}</span></td>
              <td class="px-3 py-2.5 whitespace-nowrap text-xs text-ink-500 align-top">${item.type}</td>
              <td class="px-3 py-2.5 text-xs text-ink-600 align-top">${item.reason}</td>
              <td class="px-3 py-2.5 whitespace-nowrap text-xs text-ink-400 align-top">${item.requester} · ${item.time}</td>
              <td class="px-3 py-2.5 whitespace-nowrap text-right align-top"><span class="text-warn-700 text-xs font-medium">${item.status}</span></td>
              <td class="px-5 py-2.5 whitespace-nowrap text-right align-top">
                <button onclick="${resetRequestAction(item, "确认")}" class="text-xs text-brand-700 hover:underline mr-3">确认</button>
                <button onclick="${resetRequestAction(item, "驳回")}" class="text-xs text-danger-600 hover:underline">驳回</button>
              </td>
            </tr>
          `).join("")}
        </tbody>
      </table>
    </section>
    ` : ""}

    <section class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">凭证总览 · 按游戏维度</h3>
          <p class="text-xs text-ink-500 mt-0.5">GameID / Game Secret 为游戏级，同一游戏下所有包体共享继承同一套；OpenAPI Key 按游戏维度发放，对该游戏所有包体生效。</p>
        </div>
        <button onclick="navigate('/admin/governance/games')" class="px-3 py-1.5 text-xs border border-ink-200 rounded-lg hover:bg-ink-50 whitespace-nowrap">进入游戏治理</button>
      </div>
      <table class="w-full text-sm table-fixed">
        <colgroup>
          <col style="width:13%">
          <col style="width:12%">
          <col style="width:24%">
          <col style="width:21%">
          <col style="width:21%">
          <col style="width:9%">
        </colgroup>
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-4 py-2.5 font-medium">游戏</th>
            <th class="text-left px-4 py-2.5 font-medium">GameID</th>
            <th class="text-left px-4 py-2.5 font-medium">Game Secret</th>
            <th class="text-left px-4 py-2.5 font-medium">事件上报密钥</th>
            <th class="text-left px-4 py-2.5 font-medium">数据读取密钥</th>
            <th class="text-right px-4 py-2.5 font-medium">操作</th>
          </tr>
        </thead>
        <tbody>
          ${MOCK.GAMES.map((game) => {
            const boundKeys = openApiKeys.filter((k) => k.game === game.name);
            const eventKeys = boundKeys.filter((k) => k.perm.includes("events:write"));
            const dataKeys = boundKeys.filter((k) => !k.perm.includes("events:write"));
            return `
              <tr class="border-t border-ink-100 row-hover">
                <td class="px-4 py-3.5 align-top">${gameAvatar(game)}</td>
                <td class="px-4 py-3.5 align-top">${codeChip(game.id, "brand", false)}</td>
                <td class="px-4 py-3.5 align-top">${codeChip(secretPreview(game), "warn", false, "Game Secret")}</td>
                <td class="px-4 py-3.5 align-top">${chipWrap(eventKeys.map(keyChip), "未绑定")}</td>
                <td class="px-4 py-3.5 align-top">${chipWrap(dataKeys.map(keyChip), "未绑定")}</td>
                <td class="px-4 py-3.5 align-top">
                  <div class="flex flex-col items-end gap-1.5">
                    <button onclick="navigate('/admin/governance/games')" class="text-xs text-brand-700 hover:underline whitespace-nowrap">查看包体</button>
                    <button onclick="${secretAction(game)}" class="text-xs text-amber-700 hover:underline font-medium whitespace-nowrap">重置申请</button>
                  </div>
                </td>
              </tr>`;
          }).join("")}
        </tbody>
      </table>
    </section>

    <section class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">凭证总览 · 按包体维度</h3>
          <p class="text-xs text-ink-500 mt-0.5">仅展示包体自身标识（包体名称 / 状态 / Ripple ID / Region / Platform 合并展示于「包体」列，Bundle ID / App ID 独立列出）；GameID / Game Secret / OpenAPI Key 均为游戏级凭证，见上方「按游戏维度」表。</p>
        </div>
        <button onclick="navigate('/admin/governance/games')" class="px-3 py-1.5 text-xs border border-ink-200 rounded-lg hover:bg-ink-50 whitespace-nowrap">进入游戏治理</button>
      </div>
      <table class="w-full text-sm table-fixed">
        <colgroup>
          <col style="width:13%">
          <col style="width:29%">
          <col style="width:19%">
          <col style="width:26%">
          <col style="width:13%">
        </colgroup>
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-4 py-2.5 font-medium">游戏</th>
            <th class="text-left px-4 py-2.5 font-medium">包体</th>
            <th class="text-left px-4 py-2.5 font-medium">Bundle ID</th>
            <th class="text-left px-4 py-2.5 font-medium">App ID</th>
            <th class="text-right px-4 py-2.5 font-medium">操作</th>
          </tr>
        </thead>
        <tbody>
          ${MOCK.PACKAGES.map((pkg) => {
            const game = MOCK.GAMES.find((g) => g.id === pkg.game_id);
            if (!game) return "";
            const creds = pkgCreds(pkg);
            const platformCode = packagePlatformCode(pkg.platform);
            const platformIco = platformCode === "APP_STORE" ? Icon.apple({ size: 11, color: "#64748B" }) : platformCode === "GOOGLE_PLAY" ? Icon.play({ size: 11, color: "#64748B" }) : Icon.monitor({ size: 11, color: "#64748B" });
            const flagEmoji = regionFlag(pkg.region);
            return `
              <tr class="border-t border-ink-100 row-hover">
                <td class="px-4 py-3.5 align-top">${gameAvatar(game)}</td>
                <td class="px-4 py-3.5 align-top">
                  <div class="flex items-center gap-1.5 flex-wrap mb-1">
                    <span class="text-xs font-semibold text-ink-900">${packageDisplayName(pkg, game)}</span>
                    ${pkgStatusBadge(pkg.config_status)}
                  </div>
                  <code class="font-mono text-[11px] text-ink-500 block mb-1 break-all">${pkg.id}</code>
                  <div class="flex items-center gap-1.5 text-[11px] text-ink-500 flex-wrap">
                    <span class="flex items-center gap-1 whitespace-nowrap">${flagEmoji}${pkg.region}</span>
                    <span class="text-ink-300">·</span>
                    <span class="flex items-center gap-1 whitespace-nowrap">${platformIco}${packagePlatformMeta(pkg.platform).name}</span>
                  </div>
                </td>
                <td class="px-4 py-3.5 text-xs align-top">${codeChip(pkg.bundle_id, "ink", true)}</td>
                <td class="px-4 py-3.5 text-xs align-top">
                  <div class="text-[10px] text-ink-400 mb-1 whitespace-nowrap">${packageAppIdLabel(pkg.platform)}</div>
                  ${codeChip(creds.app_id, "ink", true)}
                </td>
                <td class="px-4 py-3.5 align-top">
                  <div class="flex flex-col items-end gap-1.5">
                    <button onclick="window.open('${pkg.store_url || "#"}', '_blank')" class="text-xs text-brand-700 hover:underline whitespace-nowrap">商店链接</button>
                    <button onclick="${secretAction(game)}" class="text-xs text-amber-700 hover:underline font-medium whitespace-nowrap">重置申请</button>
                  </div>
                </td>
              </tr>`;
          }).join("")}
        </tbody>
      </table>
    </section>

    <section class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">服务端 OpenAPI Key</h3>
          <p class="text-xs text-ink-500 mt-0.5">按游戏级发放，固定分为「事件上报密钥」「数据读取密钥」两类，与研发页展示口径一致，不用于客户端 SDK 初始化。</p>
        </div>
        <button onclick="confirmAction('创建 OpenAPI Key', '新密钥仅展示一次，请确认已准备安全保存位置。', '确认创建', '已生成新 OpenAPI Key，请立即复制保存')" class="px-3 py-1.5 text-xs bg-brand-900 text-white rounded-lg hover:bg-brand-800">+ 创建 Key</button>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr><th class="text-left px-4 py-2.5 font-medium">名称</th><th class="text-left px-4 py-2.5 font-medium">App Key</th><th class="text-left px-4 py-2.5 font-medium">权限用途</th><th class="text-left px-4 py-2.5 font-medium">绑定</th><th class="text-left px-4 py-2.5 font-medium">最后使用</th><th class="text-left px-4 py-2.5 font-medium">状态</th><th class="text-right px-4 py-2.5 font-medium">操作</th></tr>
        </thead>
        <tbody>
          ${openApiKeys.map((key) => `
            <tr class="border-t border-ink-100 row-hover align-top">
              <td class="px-4 py-3"><div class="font-semibold text-ink-900">${key.name}</div><div class="text-[11px] text-ink-500 mt-1">Owner：${key.owner}</div></td>
              <td class="px-4 py-3"><code class="font-mono text-xs px-2 py-1 bg-ink-50 text-ink-700 rounded">${key.key}</code></td>
              <td class="px-4 py-3 text-xs">${permBadges(key.perm)}</td>
              <td class="px-4 py-3 text-xs text-ink-600">${key.game}<div class="mt-1 text-ink-500">${key.env}</div></td>
              <td class="px-4 py-3 text-xs text-ink-500">${key.lastUsed}</td>
              <td class="px-4 py-3">${plainStatus(key.status)}</td>
              <td class="px-4 py-3 text-right whitespace-nowrap">
                <button onclick="UI.toast('完整密钥仅创建时展示，当前只能查看脱敏信息', 'info')" class="text-xs text-brand-700 hover:underline mr-2">查看</button>
                <button onclick="${apiKeyAction(key.name, "重置申请")}" class="text-xs text-amber-700 hover:underline mr-2">重置申请</button>
                <button onclick="${apiKeyAction(key.name, "禁用")}" class="text-xs text-danger-600 hover:underline">禁用</button>
              </td>
            </tr>
          `).join("")}
        </tbody>
      </table>
    </section>

    <section class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100">
        <h3 class="text-sm font-semibold text-ink-900">凭证操作审计</h3>
        <p class="text-xs text-ink-500 mt-0.5">密钥创建、禁用、重置申请确认等均需留痕。</p>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr><th class="text-left px-4 py-2.5 font-medium">时间</th><th class="text-left px-4 py-2.5 font-medium">操作者</th><th class="text-left px-4 py-2.5 font-medium">操作</th><th class="text-left px-4 py-2.5 font-medium">对象</th><th class="text-left px-4 py-2.5 font-medium">结果</th></tr>
        </thead>
        <tbody>
          ${auditLogs.map((log) => `<tr class="border-t border-ink-100"><td class="px-4 py-3 text-xs font-mono text-ink-500">${log.time}</td><td class="px-4 py-3 text-sm">${log.user}</td><td class="px-4 py-3 text-sm">${log.action}</td><td class="px-4 py-3 text-sm">${log.target}</td><td class="px-4 py-3"><span class="text-xs font-medium ${log.result === "成功" ? "text-ok-700" : "text-warn-700"}">${log.result}</span></td></tr>`).join("")}
        </tbody>
      </table>
    </section>
  `;
};

// ---------- 个人头像上传：调用系统文件选择器后本地预览 ----------
window.handleProfileAvatarFile = function (file) {
  if (!file) return;
  if (!file.type.startsWith("image/")) {
    UI.toast("请选择图片文件", "error");
    return;
  }
  const maxSize = 500 * 1024;
  if (file.size > maxSize) {
    UI.toast("头像不能超过 500KB", "error");
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    const dataUrl = reader.result;
    const preview = document.getElementById("profile-avatar-preview");
    const fileName = document.getElementById("profile-avatar-file-name");
    if (preview) {
      preview.innerHTML = `<img src="${dataUrl}" alt="头像" class="w-full h-full object-cover" />`;
    }
    if (fileName) fileName.textContent = `${file.name} · ${(file.size / 1024).toFixed(0)}KB`;
    UI.toast("头像已上传并生成预览", "success");
  };
  reader.readAsDataURL(file);
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
;(window as any).escapeRegionCountryValue = escapeRegionCountryValue;
;(window as any).filterShareRegionCountryByContext = filterShareRegionCountryByContext;
;(window as any).getShareRegionByCode = getShareRegionByCode;
;(window as any).getShareRegionCountryPickerContext = getShareRegionCountryPickerContext;
;(window as any).getShareRegionCountrySearchKeyword = getShareRegionCountrySearchKeyword;
;(window as any).getShareRegionCountrySelection = getShareRegionCountrySelection;
;(window as any).getShareRegionCountryViewMode = getShareRegionCountryViewMode;
;(window as any).matchShareRegionCountry = matchShareRegionCountry;
;(window as any).normalizeRegionCountrySearchText = normalizeRegionCountrySearchText;
;(window as any).renderAdminOverviewModuleCard = renderAdminOverviewModuleCard;
;(window as any).renderShareAlphabetGroupedPicker = renderShareAlphabetGroupedPicker;
;(window as any).renderShareCountryCheckbox = renderShareCountryCheckbox;
;(window as any).renderShareRegionCountrySummary = renderShareRegionCountrySummary;
;(window as any).renderShareRegionGroupedPicker = renderShareRegionGroupedPicker;
;(window as any).setShareRegionCountrySelection = setShareRegionCountrySelection;
